import React from "react";
import { Helmet } from "react-helmet";

const OrganizationSchema: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: "Aptech Worldwide",
    url: "https://www.aptech-worldwide.com/",
    description:
      "Aptech Limited is a pioneer in vocational and skill development training in India. It has diverse sectors such as media & entertainment, beauty and wellness, IT, aviation and hospitality.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Aptech House, A-65, MIDC, Marol, Andheri (E)",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      postalCode: "400093",
      addressCountry: "IN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-22-68282300",
      contactType: "customer service",
      areaServed: "Worldwide",
      availableLanguage: ["en"],
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;
